// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"678":"component---src-pages-index-js","774":"framework","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"217":"fe47728e3f980e009f44","231":"1cd6c4db5d462ce1d7c9","678":"87c3da498f0d4ec29481","774":"b19807eccb99aec512c0","883":"caf5fbfd0d87f0212afe"}[chunkId] + ".js";
};